export default "__VITE_ASSET__CGd80zZM__"